import { render } from "./EditRenderer.vue?vue&type=template&id=540e6059"
import script from "./EditRenderer.vue?vue&type=script&lang=js"
export * from "./EditRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__